
import Vue, { PropType } from 'vue';

export default Vue.extend({
	name: 'BetaPluginDialog',
	props: {
		// v-model: dialog open state.
		value: {
			type: Boolean,
			default: false,
		},
		pluginName: {
			type: String,
			required: true,
		},
		pluginIcon: {
			type: String,
			required: true,
		},
		// Marketplace listing opened in a new tab as the primary CTA. The CTA is hidden when empty.
		marketplaceUrl: {
			type: String,
			default: '',
		},
		marketplaceCtaText: {
			type: String,
			default: 'Get the Plugin',
		},
		// Bug / feedback report form opened from the callout. The button is hidden when empty.
		feedbackUrl: {
			type: String,
			default: '',
		},
		// Numbered install steps, for a host whose store has no web listing. Hidden when empty.
		installSteps: {
			type: Array as PropType<string[]>,
			default: () => [],
		},
		// Optional public web page for the plugin, opened in a new tab from a secondary link
		// under the install steps. The link is hidden when empty.
		listingUrl: {
			type: String,
			default: '',
		},
		listingLinkText: {
			type: String,
			default: 'View the listing',
		},
	},
	methods: {
		close () {
			this.$emit('input', false);
		},
		onMarketplaceClick () {
			if (!this.marketplaceUrl) {
				this.close();
				return;
			}
			if (/^https?:\/\//i.test(this.marketplaceUrl)) {
				window.open(this.marketplaceUrl, '_blank', 'noopener,noreferrer');
				this.close();
				return;
			}
			// An app protocol (rhino8://) hands off to the desktop app. A new tab would stay
			// blank behind the browser's "open this app?" prompt, so navigate in place, which
			// leaves the page where it is. The dialog stays open so the install steps are still
			// on screen if the app is not installed and nothing happens.
			window.location.href = this.marketplaceUrl;
		},
		// A web page, unlike the CTA, so it always opens in a new tab and leaves the dialog
		// open: a user who came here for the steps should still have them when they come back.
		onListingClick () {
			if (this.listingUrl) {
				window.open(this.listingUrl, '_blank', 'noopener,noreferrer');
			}
		},
		onFeedbackClick () {
			if (this.feedbackUrl) {
				window.open(this.feedbackUrl, '_blank', 'noopener,noreferrer');
			}
		},
	},
});
